<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ABOUT UNIVERSITY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">University Profile</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <section class="top-position1 pb-0">
                        <div class="container-fluid px-0">
                            <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/1.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/2.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/3.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/4.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/5.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/6.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div
                                            class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background=""
                                            style="background-image: url('assets/img/sliders/7.jpg');">
                                        </div>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                </button>
                                <button class="carousel-control-next" type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                        <div class="triangle-shape top-15 right-10 z-index-9 d-none d-md-block"></div>
                        <div class="square-shape top-25 left-5 z-index-9 d-none d-xl-block"></div>
                        <div class="shape-five z-index-9 right-10 bottom-15"></div>
                    </section>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9 px-4 ">
                <div class="section-heading text-center text-md-start mb-0">
                    <span class="sub-title ">Profile</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center text-md-start">University Profile</h2>
                <p>The State Government of Himachal Pradesh founded Arni University as a State Private University. It
                    was incorporated by the ARNI University (Establishment and Regulation) Act No. 23 of 2009, which was
                    later revised by Act No. 12 of 2011, and it was officially announced as a university by No. of
                    notification: EDN
                </p>

                <p>November 3, 2009, A‐Ka (1)‐23/2007. The university is situated in the Indora Tehsil of District
                    Kangra, Himachal Pradesh, close to the village of Kathgarh. It is under the territorial control of
                    the district.
                </p>

                <p>The university's campus is situated in a picturesque setting by a running river. It is only 26
                    kilometers from Pathankot and 6 km</p>
            </div>
            <div class="col-lg-12 col-xl-12 px-4 ">
                <p>from Indora Tehsil, and it is conveniently located near the
                    national highway from Jalandhar-Pathankot. Situated in the foothills of the Dhauladhar Mountain
                    Ranges and overlooking the Beas River, the university boasts one of the most picturesque, green, and
                    pollution-free campuses.</p>
                <p>The university was founded to satisfy the goals of the residents of Kangra District in Himachal
                    Pradesh in light of the country's need for skilled labor, as envisioned by the Knowledge Commission.
                    The largest district in Himachal Pradesh is Kangra, and as of right now, there are no higher
                    education options within 200 kilometers. Therefore, the university will be able to train the
                    increasing number of students who would otherwise have to go to Amritsar, Chandigarh, Jalandhar, and
                    even Gwalior in M P.
                </p>

                <p>Its motto, "Bringing Ambition to Life," is something that the founder, faculty, and staff are
                    committed to. The values of ambition, inclusivity, integrity, equity, respect, and sustainability
                    serve as the foundation for this credo in all that we do.
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<section class="contact-form pt-0 pb-0">
    <div class="container mb-2-9 mb-md-6 mb-lg-7">
        <div class="section-heading">
            <span class="sub-title">Edge</span>
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">Arni Edge</h2>
            <div class="heading-seperator"><span></span></div>
        </div>
        <div class="row mt-n2-9 mb-md-6 mb-lg-7">

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fas fa-chalkboard-teacher"></i>
                    </div>
                    <div>
                        <h4>200+ Expert Instructors</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fa fa-building"></i>
                    </div>
                    <div>
                        <h4>State of Art Infrastructure</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon 	fas fa-pen-fancy"></i>
                    </div>
                    <div>
                        <h4>Ultra-modern class rooms</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fa fa-book"></i>
                    </div>
                    <div>
                        <h4>Elegant and well stocked library</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fa fa-wifi"></i>
                    </div>
                    <div>
                        <h4>Wi-Fi Campus</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fas fa-dumbbell"></i>
                    </div>
                    <div>
                        <h4>Multi-purpose Gyms</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fa fa-cutlery"></i>
                    </div>
                    <div>
                        <h4>Modern canteen</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon 	fas fa-hotel"></i>
                    </div>
                    <div>
                        <h4>Well maintained hostels</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon 	fas fa-microscope"></i>
                    </div>
                    <div>
                        <h4>Industry 4.0 curriculum</h4>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon fa fa-university"></i>
                    </div>
                    <div>
                        <h4>Campus placement facility</h4>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
